<template>
    <div>
        <h3 v-if="template||page">{{isTemplate?template.name:page.name}}</h3>
        <div>
            风险监测页面内容
        </div>
    </div>
</template>

<script>
    import pageTemplateService from '../../service/page-template'
    import pageService from '../../service/page'

    export default {
        name: "CompanyMonitorPagePreview",
        props: ["id", "isTemplate"],
        data() {
            return {
                template: null,
                page: null
            }
        },
        created(){
            if(this.isTemplate){
                pageTemplateService.getPageTemplate(this.id).then(response => {
                    this.template = response.data
                }).catch(() => {
                    this.$message({
                        type: 'error',
                        message: '请求出错!'
                    })
                })
            }else{
                pageService.getPage(this.id).then(response => {
                    this.page = response.data
                }).catch(() => {
                    this.$message({
                        type: 'error',
                        message: '请求出错!'
                    })
                })
            }
        }
    }
</script>
<style scoped>

</style>
